/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%]{width:100%}.wrapper[_ngcontent-%COMP%]{max-width:800px;width:96%;margin:0 auto}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29udGFpbmVycy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29udGFpbmVycy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./ngfactory/src/app/containers/app/app.component.scss.shim.ngstyle.ts